import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LoggedinService } from '../../../services/login/loggedin.service';
import { BaseService } from '../../../services/base/base.service';
import { UpcomingProgramsService } from '../../../services/upcoming-programs/upcoming-programs.service';
import { SessionHelper } from '../../../shared/services/localstorage';
import { roleID } from '../../../configurations/configuration';
import { EventService } from '../../../services/event/event.service';
import * as moment from 'moment';

@Component({
  selector: 'app-upcoming-programs',
  templateUrl: './upcoming-programs.component.html',
  styleUrls: ['./upcoming-programs.component.scss']
})
export class UpcomingProgramsComponent implements OnInit {
  _upData = [];
  roleID = roleID;
  showLoader: boolean = true;
  upDataDataFiltered = [];
  eStatus="MarketingAll";
  pageTitle = '';
  _title = '';
  @Input() type;
  @Input() isViewAll;
  @Input() title;
  @Input() set upData(value: any) {
    this._upData = value;
    console.log("-----------------",this._upData);
    if(this._upData && this._upData.length >= 0) {
      this.upDataDataFiltered = [];
      this.pageNumber = 1;

      this.upDataDataFiltered = this._upData;
      this.showLoader = false;
    }
    else {
      this.showLoader = false;
    }
  }
  get upData(): any {
    // other logic
    return this.upDataDataFiltered;
  }
  pageSize: number = 10;
  pageNumber: number = 1;
  totalRecords: number;
  filterObj = {};
  user: any;
  status = [];
  role: number;
  constructor(private eventService: EventService,public loggedInService: LoggedinService, private upcomingProgramsService: UpcomingProgramsService) { }
  ngOnInit() {
    this.showLoader = true;
    this.user = SessionHelper.getSession();
    this.role = this.user.role_id;
    console.log(this.role);
    if(this.role===roleID.BRAND_ADMIN_ROLE_ID){
      this.filterObj = {
        brandId: this.user.brand_id,
        type: this.type
      } 
    }
    else if(this.role===roleID.MARKETING_ROLE_ID){
      // this.getAllEventStatus();
      this.title = "Programs";
    }
    else if(this.role === roleID.SALES_REP_ROLE_ID) {
      this.filterObj = {
        userId: this.user.id,
        brandId: this.user.brand_id,
        type: this.type
      }
      if(this.title) {
        this.pageTitle = this.title;
      }
      else {
        this.pageTitle = "Upcoming Programs";
      }
    }
  }

   
  getAllEventStatus() {
    this.eventService.getEventStatus().subscribe((result: any) => {
      console.log(result);
      this.status = result.data;
    })
  }


  selectedStatus(event) {
    this.showLoader = true;

    this.upDataDataFiltered = [];
    let type = this.eStatus


    if(type=='')
      type= 'MarketingAll';


      if(type=="Completed"){
       // status ID = 6


        this.filterObj = {
          brandId: this.user.brand_id,
          type: 6,
        } 
       
        this.upcomingProgramsService.getUpcomingEvents({}, this.filterObj, 1000, 0).subscribe((result:any) => {
          console.log("filteredDate", result);
          result.data.data.forEach(element => {
            element['date'] = moment(element.date, "YYYY-MM-DD").format("MM-DD-YYYY");
          });
            this.upDataDataFiltered = result.data.data;
            this.showLoader = false;
      },
        err => {
        });    


      }else{
        this.filterObj = {
          brandId: this.user.brand_id,
          type: type,
        } 
       
        this.upcomingProgramsService.getUpcomingEvents( [] ,this.filterObj, 1000, 0).subscribe((result: any)=> {
          console.log(result)
          if(result.status) {    
            console.log("getUpcomingEvents", result.data);
            result.data.data.forEach(element => {
              element['date'] = moment(element.date, "YYYY-MM-DD").format("MM-DD-YYYY");
            });   
            this.upDataDataFiltered = result.data.data;
            this.showLoader = false;
    
          }
        },
        err=> {
          console.log("Error", err);
        });        
        
      }

  
  }

  pageChanged(pN: number): void {
    this.pageNumber = pN;
  }

}
